import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { PieChart } from "react-minimal-pie-chart";
import "./ITManagedDevices.scss";

const colors = {
  servers: "#3379C0",
  workstations: "#84D3F5"
};

const ITManagedDevicesScore = ({ contract }) => {
  const contractObjects = useMemo(() => {
    const allDevices = contract.servers + contract.workstations;
    return {
      servers: (contract.servers * 100) / allDevices,
      workstations: (contract.workstations * 100) / allDevices
    };
  }, [contract]);

  return (
    <div>
      {contractObjects ? (
        <div className="active-projects-container">
          <h1>Managed Devices</h1>
          <div className="active-projects-wrapper">
            <div className="active-projects-chart md-chart">
              <PieChart
                style={{ height: "200px" }}
                lineWidth={20}
                label={() =>
                  `${(contract.servers + contract.workstations || 0)
                    .toFixed(1)
                    .replace(/[.,]0$/, "")}`
                }
                labelPosition={0}
                data={Object.keys(contractObjects).map((key) => ({
                  title: `${key.toUpperCase()}`,
                  value: contractObjects[key] || 100,
                  color: contractObjects[key] ? colors[key] : "#e8e8e9"
                }))}
              />
            </div>
            <div className="active-projects-list-container">
              <div className="active-projects-list-wrapper">
                <h4>{contract.servers || 0} Servers</h4>
                <div
                  className="active-projects-legend"
                  style={{ backgroundColor: colors.servers }}
                />
              </div>
              <div className="active-projects-list-wrapper">
                <h4>{contract.workstations || 0} Workstations</h4>
                <div
                  className="active-projects-legend"
                  style={{ backgroundColor: colors.workstations }}
                />
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="no-active-projects-container">
          <h4>No Data To Show</h4>
        </div>
      )}
    </div>
  );
};
ITManagedDevicesScore.propTypes = {
  contract: PropTypes.object
};
ITManagedDevicesScore.defaultProps = {
  contract: {}
};
export default ITManagedDevicesScore;
